// extracted by mini-css-extract-plugin
export default {"flexDisplay":"ArrowPayment_flexDisplay__qeFiX","arrow":"ArrowPayment_arrow__FYkAQ"};